import { api, helpers, ts } from '_core';

type PortfolioApiResponse = {
  data: ts.types.portfolio.Portfolio;
};

export const createPortfolio = async (
  newData: ts.types.portfolio.PortfolioDraft,
  callback: (_data: ts.types.portfolio.Portfolio) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    const resp: PortfolioApiResponse = await api.portfolios.create(newData);
    callback(resp.data);
  } catch (error) {
    errorCallback(`Error creating portfolio - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};

export const updatePortfolio = async (
  id: number,
  newData: ts.types.portfolio.PortfolioDraft,
  callback: (_data: ts.types.portfolio.Portfolio) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    const resp: PortfolioApiResponse = await api.portfolios.update(id, newData);
    callback(resp.data);
  } catch (error) {
    errorCallback(`Error updating portfolio - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};

export const updateUiMetadata = async (
  id: number,
  uiMetaData: ts.types.portfolio.UiMetaData,
  callback: (_data: ts.types.portfolio.Portfolio) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    const updateData = {
      ui_metadata: uiMetaData,
      skip_signature_check: true,
    } as ts.types.portfolio.PortfolioDraft;
    const resp = await api.portfolios.update(id, updateData);
    callback(resp.data);
  } catch (error) {
    errorCallback(`Error updating the resource metadata - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};
